export default {
  newDesign: true,
  parameters: {
    landing_id: "LatQuFT",
    segment: 14,
  },
  title:
    "Responde las preguntas para inscribirte en tu primera clase de prueba | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "¡Responde 5 preguntas y recibe una clase gratuita para tu niño o niña!",
    subtitle: "¡Todo adaptado a su edad y ritmo de aprendizaje!",
    image: {
      url: "/welcome/latam_5_7_new_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_5_7_new_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "Empezar el quiz 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  customStopPages: {
    child: {
      title:
        "Lamentablemente, solo un padre o tutor puede inscribir a un estudiante en las clases.",
      subtitle:
        "Si quieres continuar, puedes compartir este enlace con tus padres.<br>¡Ojalá podamos verte pronto en nuestras clases! ",
      image: "/welcome/quizV2/child-parent.png",
    },
  },
  quizRotateBySteps: {
    1: {
      question: "¿Eres mamá, papá, otro familiar o hijo/a?",
      answers: [
        "👨‍👩‍👧 Padre / madre / tutor",
        { 
          answer: "👦👧Niño / niña",
          stopAnswer: true,
          customStopPageId: "child",
        },
        
      ],
    },
    2: {
      question:
        "¿Qué tipo de actividades disfruta más tu hijo o hija?",
      answers: [
        "🎨 Dibujar, colorear o hacer manualidades",
        "🧩 Resolver rompecabezas o construir con bloques",
        "🎮 Jugar en la tablet o en la computadora",
        "📖 Inventar historias o imaginar nuevos mundos",
        "🎵 Cantar, bailar o hacer música",
        "🌳 Explorar la naturaleza y descubrir cómo funcionan las cosas",
      ],
    },
    3: {
      title: "¿Qué edad tiene tu hijo o hija?",
      type: "age",
      button: "",
    },
    4: {
      question: "¿Tienen una computadora o laptop que tu hijo o hija pueda usar para las clases?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    5: {
      question: "¿Te gustaría que tu hijo o hija…",
      subtitle: "(elige lo que suena más emocionante)",
      answers: [
        "🎮 Cree su primer videojuego",
        "🎨 Diseñe su propio dibujo animado o caricatura",
        "💻 Aprenda a programar juegos y proyectos simples",
        "🧱 Diseñe en 3D y construya mundos creativos",
        "🌈 Aprenda jugando y creando",
        "✨ ¡De todo un poco!",
      ],
    },
    6: {
      title: "🎉 ¡Solo un paso más!",
      typeInfo: "congrats",
      subtitle:
        "Ayuda a tu hijo a explorar su lado creativo con programación y diseño digital.<br>🌟 Ya son más de 200.000 niños creando y aprendiendo con nosotros.",
      button: "📅 ¡Reserva una clase gratis!",
    },
    7: {
      title: "Reserva una clase gratuita",
      type: "one-page-contacts",
      subtitle: "",
      button: "Casi terminamos 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    10: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    11: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
